import { combineReducers } from 'redux';

import business_group from '../businessGroup';
import difficulty from '../system/difficulty';
import game from '../system/game';
import game_session from '../game_session';
import game_session_activity from '../game_session_activity';
import game_skill from '../system/game_skill';
import game_skill_position from '../system/game_skill_position';
import level from '../system/level';
import menu from '../application/menu';
import organization from '../organization';
import pages from '../application/pages';
import player from '../player';
import player_game_session from '../player_game_session';
import player_game_session_activity from '../player_game_session_activity';
import position from '../system/position';
import result from '../result';
import result_view from '../views/result_view';
import role from '../system/role';
import setting from '../system/setting';
import skill from '../system/skill';
import user from '../user';
import masquarade from '../system/masquarade';
import splitIO from '../splitIO';
import functionalSkills from '../functional_skills';
import restoreTogether from '../restore_together';
import tournament from '../tournament';
import webcore from '../webcore';
import occupation from '../occupation';
import navigation from '../navigation';
import offline_mode from '../application/offline';

export default combineReducers({
  business_group,
  difficulty,
  functionalSkills,
  game_session_activity,
  game_session,
  game_skill_position,
  game_skill,
  game,
  level,
  masquarade,
  menu,
  organization,
  pages,
  player_game_session_activity,
  player_game_session,
  player,
  position,
  restoreTogether,
  result_view,
  result,
  role,
  setting,
  skill,
  splitIO,
  tournament,
  webcore,
  user,
  occupation,
  navigation,
  offline_mode,
});
